import { render, staticRenderFns } from "./JOURNALISATION.vue?vue&type=template&id=1dee5110"
import script from "./JOURNALISATION.vue?vue&type=script&lang=js"
export * from "./JOURNALISATION.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports